var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',{staticClass:"text-center"},[_vm._v("Draft")]),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('Draftpemohon')],1)]),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('Draftpelapor')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }